// extracted by mini-css-extract-plugin
export default {"Emoji":"bbz_a bib_i bib_q bib_j"};